import { useState, useEffect, useRef } from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function PatientsProvidersSupport() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  const patientItems = ["Equipment delivered and set up in your home", "24/7 patient support and education", "Insurance coordination handled for you"];
  const providerItems = ["Fast, documented intake and order turnaround", "Direct clinical communication with case managers and wound care teams", "Compliant documentation and full insurance verification"];
  return <section id="PatientsAndProvidersSupport" ref={sectionRef} className="bg-[#F5F4F1] text-[#1A1A1A] font-sans">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500&family=Inter:wght@300;400;600&display=swap');
        .tailored-btn:hover {
          opacity: 0.9;
          transform: scale(1.01);
          transition: all 0.2s ease;
        }
        .tailored-card:hover {
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
          transition: box-shadow 0.3s ease;
        }
      `}</style>
      <div className="md:pt-32 md:pb-32 pt-24 pb-24">
        <div className="page-container">
          <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="flex flex-col items-center text-center mb-12 md:mb-16">
              <span className="font-semibold tracking-[0.1em] text-[#E51F26] uppercase mb-3" style={{
              fontSize: "11px"
            }}>
                TAILORED SUPPORT
              </span>
              <h2 className="text-[#1A1A1A] font-serif text-[48px] font-normal leading-[48px] tracking-[-1.2px] max-w-[600px] mx-auto">
                Built for patients and the providers who refer them.
              </h2>
              <div className="w-8 h-[2px] bg-[#E51F26] mt-4" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {}
              <div className="tailored-card bg-white rounded-lg shadow-md p-12 flex flex-col">
                <span className="font-semibold tracking-[0.08em] text-[#E51F26] uppercase mb-3" style={{
                fontSize: "11px"
              }}>
                  FOR PATIENTS & FAMILIES
                </span>
                <h3 className="text-[#1A1A1A] font-serif text-[30px] font-normal leading-[36px] tracking-[-0.75px] mb-5">
                  Healing at home, with dignity.
                </h3>
                <p className="text-muted-foreground font-light text-base leading-[26px] mb-6">
                  Taking home therapy equipment can feel daunting. We provide hands-on patient education, straightforward guides, and full insurance orchestration so you can focus entirely on recovery.
                </p>
                <ul className="list-none p-0 m-0 mb-auto space-y-3">
                  {patientItems.map((item, i) => <li key={i} data-index={i} className="text-[#1A1A1A] font-sans text-base font-normal leading-6 flex items-center gap-2.5">
                      <Check className="w-3.5 h-3.5 text-[#E51F26] shrink-0" />
                      {item}
                    </li>)}
                </ul>
                <div className="mt-9">
                  <Link to="#" className="tailored-btn w-full inline-block text-white font-sans text-[12px] font-semibold leading-4 tracking-[0.6px] bg-[#E51F26] py-4 px-6 uppercase text-center rounded-lg shadow-md min-h-[48px]">
                    CONTACT OUR PATIENT TEAM
                  </Link>
                </div>
              </div>

              {}
              <div className="tailored-card bg-white rounded-lg shadow-md p-12 flex flex-col">
                <span className="font-semibold tracking-[0.08em] text-[#E51F26] uppercase mb-3" style={{
                fontSize: "11px"
              }}>
                  FOR HEALTHCARE PROVIDERS
                </span>
                <h3 className="text-[#1A1A1A] font-serif text-[30px] font-normal leading-[36px] tracking-[-0.75px] mb-5">
                  A referral partner you can trust.
                </h3>
                <p className="text-muted-foreground font-light text-base leading-[26px] mb-6">
                  We streamline the DME order pathway. From fast clinical evaluations to comprehensive documentation, we align with clinicians and discharge specialists to ensure patients receive critical equipment with zero delays.
                </p>
                <ul className="list-none p-0 m-0 mb-auto space-y-3">
                  {providerItems.map((item, i) => <li key={i} data-index={i} className="text-[#1A1A1A] font-sans text-base font-normal leading-6 flex items-center gap-2.5">
                      <Check className="w-3.5 h-3.5 text-[#E51F26] shrink-0" />
                      {item}
                    </li>)}
                </ul>
                <div className="mt-9">
                  <Link to="#" className="tailored-btn w-full inline-block text-white font-sans text-[12px] font-semibold leading-4 tracking-[0.6px] bg-[#E51F26] py-4 px-6 uppercase text-center rounded-lg shadow-md min-h-[48px]">
                    REFER A PATIENT
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}